<template>
    <CCard accent-color="info">
        <CCardHeader>
            <h4>Nuevo Cliente</h4>
        </CCardHeader>
        <CCardBody>
            <CInput
                v-model="clienteNuevo.rutCliente"
                label="Rut"
                type="text"
                horizontal
                placeholder="12345678-9"
            />
            <CInput
                v-model="clienteNuevo.nombreCliente"
                label="Nombre"
                type="text"
                horizontal
            />
            <CInput
                v-model="clienteNuevo.rutaCarpetaBd"
                label="ruta Carpeta Bd"
                type="text"
                horizontal
            />
            <CInput
                v-model="clienteNuevo.carpetaRaiz"
                label="Carpeta Raiz"
                type="text"
                horizontal
                placeholder="soloEdig"
            />
            <CRow>
                <CCol>
                    <CSwitch
                        width="150px"
                        class="mx-1 align-middle mb-2 mt-2" 
                        color="success" 
                        shape="pill"
                        variant="outline"
                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                        :checked="clienteNuevo.habilitarGesto"
                        @update:checked="clienteNuevo.habilitarGesto = !clienteNuevo.habilitarGesto"
                    /> Habilitar Gesto
                </CCol>
            </CRow>
            <CRow>
                <CCol><!--v-c-tooltip.hover="{content:'Habilitar Compartida archivos', placement:'left'}"-->
                    <CSwitch
                        width="150px"
                        class="mx-1 align-middle mb-2 mt-2" 
                        color="success" 
                        shape="pill"
                        variant="outline"
                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                        :checked="clienteNuevo.habilitarCompartida"
                        @update:checked="clienteNuevo.habilitarCompartida = !clienteNuevo.habilitarCompartida"
                    /> Habilitar Compartida
                </CCol>
            </CRow>
            <CRow>
                <CCol>
                    <CSwitch
                        width="150px"
                        class="mx-1 align-middle mb-2" 
                        color="success" 
                        shape="pill"
                        variant="outline"
                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                        :checked="clienteNuevo.tipoBdRemu"
                        @update:checked="clienteNuevo.tipoBdRemu = !clienteNuevo.tipoBdRemu"
                        /> Usa Remuneraciones
                </CCol>
            </CRow>
            <CRow>
                <CCol>
                    <CSwitch
                        width="150px"
                        class="mx-1 align-middle mb-2" 
                        color="success" 
                        shape="pill"
                        variant="outline"
                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                        :checked="clienteNuevo.tipoBdConta"
                        @update:checked="clienteNuevo.tipoBdConta = !clienteNuevo.tipoBdConta"
                    /> Usa Contantabilidad
                </CCol>
            </CRow>
            
        </CCardBody>
        <CCardFooter>
            <CButton type="submit" size="sm" class="btn-class" 
                :disabled="isCreandoCliente"
                @click="agregarCliente">
                <CIcon name="cil-check-circle" :class="isCreandoCliente?'imgr':''"/> Crear Cliente 
            </CButton>
            <CIcon
            class="ml-2"
                v-show="mostrarMensajes"
                v-tippy="{ 
                    placement: 'top',
                    arrow: true, 
                    arrowType: 'round', 
                    animation:'fade',
                    theme: 'google',
                    followCursor : true,
                    content: mensajesAgregarCliente
                }"
                :content="$options.freeSet.cilWarning"
            />
        </CCardFooter>
    </CCard>

</template>

<script>
    import Vue from 'vue'
    import cons from "@/const";
    import axios from "axios";
    import { freeSet } from "@coreui/icons";
import { CRow } from '@coreui/vue';

    export default {
        name: "NuevoCliente",
        freeSet,
        components: {
        },
        props: {
            mostrarAgregarNuevoCliente: Boolean
        },
        data() {
            return {
                paginaActual: 1,

                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,

                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,
                
                
                isCreandoCliente: false,
                mensajesAgregarCliente: "",
                mostrarMensajes: false,
                clienteNuevo: {
                    "rutCliente": "",
                    "nombreCliente": "",
                    "rutaCarpetaBd": "",
                    "idUnidadDrive": "",
                    "carpetaRaiz": "",
                    "habilitarGesto": false,
                    "habilitarCompartida": false,
                    "tipoBdRemu": false,
                    "tipoBdConta": false,
                },
            };
        },
        created: function () {},
        beforeMount() {
        },
        mounted() {},
        methods: {
            agregarCliente: function(){
                var url = this.baseUrl + "/agregar_cliente/";
                this.isCreandoCliente = true

                axios({
                    method: "POST",
                    "url": url,
                    "data": {
                        "rutCliente": this.clienteNuevo.rutCliente,
                        "nombreCliente": this.clienteNuevo.nombreCliente.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
                        "rutaCarpetaBd": this.clienteNuevo.rutaCarpetaBd,
                        //"idUnidadDrive": this.clienteNuevo.idUnidadDrive,
                        "carpetaRaiz": this.clienteNuevo.carpetaRaiz,
                        "habilitarGesto": this.clienteNuevo.habilitarGesto,
                        "habilitarCompartida": this.clienteNuevo.habilitarCompartida,
                        "tipoBdRemu": this.clienteNuevo.tipoBdRemu,
                        "tipoBdConta": this.clienteNuevo.tipoBdConta,
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {

                    this.$notification.success(result.data.mensajeGeneral, {  timer: 10, position:"bottomRight"});
                    this.mensajesAgregarCliente = result.data.mensajes
                    this.mostrarMensajes = true
                    
                    this.$emit("actualizarClientes")
                    
                }, error => {
                    let mensaje = `Problema al obtener Clientes, ${error}`
                    this.$notification.error(error.response.data.mensajeGeneral, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                    this.isCreandoCliente = false
                });
            },

        },
    };
</script>

<style>


</style>